import { selectOldStripeData } from "@store/slices/accountSlice";
import useStore from "@store/store";
import React from "react";

const ResubscribeCta = () => {
  const oldStripeData = useStore(selectOldStripeData);

  return (
    <div className="w-full ml-8 mb-4 md:w-3/4 p-4 mt-4 flex flex-col gap-4 rounded-xl bg-gradient-to-r from-red-100 to-red-50 border">
      <p className="font-bold">
        AI Excel Bot has been acquired by Dream Shake Media LLC.
      </p>
      <p>
        We are pleased to offer you a complimentary month of our Pro
        subscription plan for free, starting from the end date of your current
        plan. Your free Pro access will end in{" "}
        <span className="font-bold">
          {Math.floor(
            (oldStripeData.current_period_end.seconds * 1000 - Date.now()) /
              86400000
          )}{" "}
          days .
        </span>{" "}
        You will need to resubscribe to our pro plans before the end of this
        period to continue with your unlimited access.
      </p>
    </div>
  );
};

export default ResubscribeCta;
